const renderCredits = credits => credits.map(credit => (
  `${credit.hoursString} ${credit.typeName.trim()}`
)).join(', ');

export default renderCredits;
